import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import { TRAVEL_HEALTH_PREMIUM_INTERVAL } from '@flows/configs/travelHealthNxt/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import Schema_Quote from '@flows/insurance/schemas/shared/Schema_Quote'

const travel_quote = (params: StepConfigParams) =>
  ({
    validationStrategy: 'onChange',
    schema: Schema_Quote.merge(
      schemaUtils.generateZodObjectFromPaths({
        product_keys: z.object({ [params.productKey]: z.boolean().optional() }).optional(),
      })
    ),
    stepContent: [
      {
        type: 'customComponent',
        name: 'QuoteStep',
        props: {
          product: params.productKey,
          isCoveragePlanSelectorHidden: true,
          allowedPremiumIntervals: [TRAVEL_HEALTH_PREMIUM_INTERVAL],
        },
        inputs: [],
        outputs: [],
      },
    ],
    nextStep: 'emailAndName',
    subFlow: params.subFlow,
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareQuoteStep',
        options: {
          productKey: params.productKey,
        },
        inputs: [],
        outputs: [],
      },
    },
    showOrderSummary: true,
    nonStickyFooter: true,
  }) as const satisfies AnyStepConfiguration

export default travel_quote
